<div class="loaderContainer" *ngIf="system?.isLoading">
  <div class="messageContainer">
    <span>{{ system?.loadingMessage }}</span>
  </div>
</div>
